import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import { BrowserView, isBrowser, MobileView } from "react-device-detect";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import users from "../../assets/images/icon_profile/user.svg";
import Config from "../../config/Config";
import { setLoading } from "../../core/feature/config/configSlice";
import { getRewardData, violationPointDashboard } from "../../core/service/api_violation_point";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ViolationPointRewardMobile from "./violationPointRewardMobile";
import ViolationPointRewardWeb from "./violationPointRewardWeb";
import moment from "moment";

const ViolationPointRewardComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("ViolationPoint");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isScanOpen, setIsScanOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isScan, setIsScan] = useState(false);
  const [students, setStudents] = useState<any>([]);
  const [isToken, setIsToken] = useState<any>(false);
  const { t } = useTranslation();
  const [data, setData] = useState<any>([]);
  const [dataPoint, setDataPoint] = useState<any>({});
  const [studentSelected, setStudentSelected] = useState<any>({});
  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0
  })
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const env = Config.BaseUrlDev;

  const closeModal = () => {
    setIsOpen(false);
    navigate(`/home`, { replace: true });
  };
  const openModal = () => {
    setIsOpen(true);
  };
  const toScanPage = (studentId: string, grade: string) => {
    navigate(`/pickup-student/scan/${studentId}/${grade}`);
  };
  const toQRPage = (studentId: string, grade: string, studentName: string) => {
    navigate(`/pickup-student/create-qr/${studentId}/${grade}/${studentName}`);
  };
  const toBookingPage = () => {
    navigate(`/pickup-student/booking`);
  };
  const toStatusBookingPage = () => {
    navigate("/pickup-student/status");
  };

  const getDashboard = async (studentId: string) => {
    try {
      let query = [];
      query.push(`student_id=${studentId}`);
      if (startDate && endDate) {
        query.push(`start_date=${startDate}`);
        query.push(`end_date=${endDate}`);
      }
      dispatch(setLoading(true));
      let response = await violationPointDashboard(query);
      console.log(response)
      setDataPoint(response.data);
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(setLoading(false));
    }
  };

  const fetchData = async (e: any = {}, loadMore: boolean = false, reset: boolean = false) => {
    try {
      let query: any = [];
      if (e.startDate) query.push(`start_date=${e.startDate}`);
      if (e.endDate) query.push(`end_date=${e.endDate}`);
      const studentSelect: any = localStorage.getItem("selectStudent")
        ? JSON.parse(localStorage.getItem("selectStudent") as string)
        : {};
      query.push(`student_id=${studentSelect.id}`);
      if (loadMore) query.push(`page=${pagination.page + 1}`);
      else if (reset) query.push(`page=1`)
      else query.push(`page=${pagination.page}`);
      query.push(`size=${pagination.size}`);
      dispatch(setLoading(true));
      let res = await getRewardData(query);
      if (loadMore) setData([...data, ...res.data.items]);
      else setData(res.data.items);
      setStudentSelected(studentSelect)
      setPagination({
        page: res.data.page,
        size: res.data.size,
        total: res.data.total
      })
    } catch (error) {
      console.log(error)
    } finally {
      dispatch(setLoading(false));
    }
  };

  const changeStudent = (value: any) => {
    setStudentSelected(value);
    setIsOpen(false);
    localStorage.setItem("selectStudent", JSON.stringify(value))
  };

  const getProfileImage = (photo: string) => {
    if (photo == "") return users;
    return env + "main_base/image/get/" + photo + "/pas";
  };
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "Point Pelanggaran",
    });
    const studentSelect: any = localStorage.getItem("selectStudent")
      ? JSON.parse(localStorage.getItem("selectStudent") as string)
      : {};
    setStudentSelected(studentSelect)
    getDashboard(studentSelect.id);
    fetchData({ startDate: startDate, endDate: endDate })
  }, []);

  useEffect(() => {
    if (startDate && !endDate || !startDate && endDate) return
    fetchData({ startDate: startDate, endDate: endDate })
    if (studentSelected.id) getDashboard(studentSelected.id)
  }, [startDate, endDate]);
  return (
    <>
      <BrowserView>
        <Transition appear show={isOpen} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={closeModal}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div className="flex flex-row">
                        {/* <img
                          src={helpIcon}
                          alt=""
                          className="text-black mr-2"
                        /> */}
                        {/* <div>{t("DIGITALCARD.help")}</div> */}
                      </div>
                    </Dialog.Title>
                    <div className="rounded-2xl bg-psp-primary mt-3 p-2">
                      Mohon maaf, Fitur ini belum tersedia pada perangkat
                      desktop
                    </div>
                    <div>
                      <button
                        type="button"
                        className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                        onClick={closeModal}
                      >
                        {t("OTHER.back")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
        <ViolationPointRewardWeb
          toScanPage={toScanPage}
          toBookingPage={toBookingPage}
          toQRPage={toQRPage}
          toStatusBookingPage={toStatusBookingPage}
        ></ViolationPointRewardWeb>
      </BrowserView>
      <MobileView>
        <ViolationPointRewardMobile
          key={`${JSON.stringify(data).length}-${JSON.stringify(students).length}-${JSON.stringify(studentSelected).length}-${JSON.stringify(dataPoint).length}`}
          getProfileImage={(e: string) => getProfileImage(e)}
          changeStudent={(e: any) => changeStudent(e)}
          studentSelect={studentSelected}
          data={data}
          pagination={pagination}
          startDate={startDate}
          setStartDate={(e: any) => setStartDate(e)}
          endDate={endDate}
          setEndDate={(e: any) => setEndDate(e)}
          dataPoint={dataPoint}
          fetchData={(e: any, loadMore: boolean) => fetchData(e, loadMore)}
        ></ViolationPointRewardMobile>
      </MobileView>
    </>
  );
};

export default ViolationPointRewardComponent;
